// src/contexts/ContractCountContext.js
import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { getArtistContractCount } from '../api/artistCounts';
import { useArtistAuth } from './ArtistAuthContext';

const ContractCountContext = createContext();

export const ContractCountProvider = ({ children }) => {
  const [contractCount, setContractCount] = useState(0);
  const { artistUser, checking } = useArtistAuth() || {};

  const fetchContractCount = useCallback(async () => {
    if (checking || !artistUser) {
      return;
    }
    try {
      const data = await getArtistContractCount();
      setContractCount(data.count);
    } catch (error) {
      console.error('Error fetching contract count:', error);
    }
  }, [artistUser, checking]);

  // マウント時に1回取得
  useEffect(() => {
    fetchContractCount();
  }, [fetchContractCount]);

  // 他コンポーネントから再取得できるように関数を公開
  const refreshContractCount = useCallback(async () => {
    await fetchContractCount();
  }, [fetchContractCount]);

  useEffect(() => {
    if (!checking && !artistUser) {
      setContractCount(0);
    }
  }, [artistUser, checking]);

  return (
    <ContractCountContext.Provider value={{ contractCount, refreshContractCount }}>
      {children}
    </ContractCountContext.Provider>
  );
};

export const useContractCount = () => useContext(ContractCountContext);
